import React from 'react';
import { Link, useRouteMatch, Switch, Route, Redirect } from 'react-router-dom';
import { Menu, Layout } from 'antd';
import ErrorBoundary from 'components/ErrorBoundary';
import { generatePath } from 'react-router';
import useUser from 'hooks/useUser';
import Loading from 'components/Loading';
import useCustomer from 'hooks/useCustomer';
import routes from './routes';

const { Header, Content } = Layout;

const Tools = () => {
  const { path, params } = useRouteMatch('/tools/:page?');
  const { hasPermission, loading } = useUser();
  const { hasCustomerPermission } = useCustomer();

  if (loading) {
    return <Loading />;
  }

  const hasAccessToRoute = r => !r.permission || hasPermission(r.permission) || hasCustomerPermission(r.permission);

  const filteredRoutes = routes.filter(hasAccessToRoute);

  const items = filteredRoutes.filter(r => r.label).map(route => ({
    key: route.path,
    label: <Link to={generatePath(path, { ...params, page: route.path })}>{route.label}</Link>,
  }));

  return (
    <Layout>
      <Header className="app__subnav nav">
        <Menu mode="horizontal" items={items} selectedKeys={[params?.page]} />
      </Header>
      <Content>
        <ErrorBoundary>
          <Switch>
            {filteredRoutes.map(route => (
              <Route
                key={route.path}
                exact={route.exact}
                path={`/tools/${route.path}`}
                component={route.component}
              />
            ))}
            <Route path="*">
              <Redirect to={generatePath(path, { ...params, page: routes[0].path })} />
            </Route>
          </Switch>
        </ErrorBoundary>
      </Content>
    </Layout>

  );
};

export default Tools;
